import React from 'react';

import PDFViewer from './pdfViewer.container';
import { fichasData } from '../../data/fichas.data';

interface Props {
  showPDF: boolean,
  handleShowPDF: (payload: boolean) => void
  currentCarSelected: string,
  currentModelSelected: string
}

interface State {
  pdfPath: string
}

class PDFViewerMenu extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = {
      pdfPath: '',
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if ((this.props.currentModelSelected !== prevProps.currentModelSelected) || (this.props.currentCarSelected !== prevProps.currentCarSelected)) {
      var fichas: any = fichasData()
      /*var ficha = fichas[this.props.currentCarSelected + " " + this.props.currentModelSelected];
      if(ficha == null)*/
      
      this.setState({
        pdfPath: fichas[this.props.currentCarSelected + " " + this.props.currentModelSelected]
      })
    }
  }

  render(): React.ReactNode {
    return (
      <div className={`pdfviewer-global ${(this.props.showPDF) ? 'fade-in' : 'fade-out'}`}>
        {this.state.pdfPath ?
          <div className='pdfviewer-menu'>
            <PDFViewer
              pdfPath={this.state.pdfPath}
            />
            <div className='pdfviewer-close-btn' onClick={() => this.props.handleShowPDF(false)}>CERRAR FICHA TÉCNICA</div>
          </div> : null
        }
      </div>
    )
  }
}

export default PDFViewerMenu